import axios from 'axios';
import router from '@/router/index.js';
import store from '@/store/index.js';
import castleService from '@/services/castle';

axios.interceptors.request.use(
  async function (config) {
    try {
      const requestToken = await castleService.generateRequestToken();

      if (requestToken) {
        config.headers['Castle-Token'] = requestToken;
      }
    } catch (error) {
      console.warn(
        'Castle: Failed to add request token to axios request',
        error
      );
    }

    // Session conflict detection: compare the in-memory Vuex user ID
    // against the last user ID written to localStorage (shared across tabs).
    // When another user logs in from a different tab, setCurrentUser writes
    // their ID to localStorage, making the mismatch detectable here.
    const lastActiveUId = localStorage.getItem('hw_active_user_id');
    const storeUId = store.state.users.currentUser?.id;

    if (
      storeUId &&
      lastActiveUId &&
      String(storeUId) !== String(lastActiveUId)
    ) {
      console.warn(
        `Session conflict detected: Vuex user ${storeUId} vs active user ${lastActiveUId}. Another user signed in from a different tab.`
      );
      window.location.reload();
      return Promise.reject(
        new axios.Cancel('Session conflict: another user signed in')
      );
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger

    return response;
  },
  function (error) {
    if (
      error?.response?.status === 422 &&
      error?.response?.data?.error === 'castle denial'
    ) {
      window.location.href = `${window.location.origin}/onboarding/security/unauthorized`;
      return;
    }
    const requiredAuthorization = verifyAuthentication(
      router.currentRoute.value?.meta
    );

    if (
      error?.response?.status === 401 &&
      requiredAuthorization &&
      store.state.users.currentUser?.id
    ) {
      store.commit('users/setCurrentUser', null);
      window.location.replace(window.location.origin + '/onboarding/sign-up');
    } else if ([406].includes(error?.response?.status)) {
      // A Block by the server on the user.  They need to follow
      // the URL provided in the response
      window.location.replace(error?.response?.data?.url);
    } else if (
      [401, 403, 404, 422, 429, 500].includes(error?.response?.status)
    ) {
      // Show error banner for non-excluded endpoints
      let excludedEndpoints = store.state.errors.excludedEndpoints;
      if (!excludedEndpoints?.includes(error?.response?.config?.url)) {
        store.commit('errors/setAllErrors', error?.response);
        store.commit('errors/setShowErrorBanner', true);
      }
    }
    return Promise.reject(error);
  }
);

function verifyAuthentication(auth) {
  if (auth === undefined) return false;
  if (auth?.doesNotRequireAuthentication) return false;
  return true;
}

export default axios;
